<template>
  <SoPageWithHeader title="Freshdesk Contacts">
    <FreshdeskContactsTable />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import FreshdeskContactsTable from "./components/FreshdeskContactsTable.vue"

  export default defineComponent({
    components: {
      SoPageWithHeader,
      FreshdeskContactsTable,
    },
  })
</script>
